"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscriptions = void 0;
const types_1 = require("@air/types");
const querystring_1 = require("querystring");
const request_1 = require("./request");
function get(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            workspaceId,
        });
    });
}
/**
 *
 * @param token Stripe's representation of sensitive payment information
 * @param planId
 * @param coupon
 */
function purchaseThroughStripe(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, token, planId, coupon, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: 'stripe/plan',
            method: 'POST',
            body: {
                token,
                planId,
                coupon,
            },
            workspaceId,
        });
    });
}
/**
 *
 * @param planId
 * @param coupon
 */
function purchaseStripePlan(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, planId, coupon, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: 'stripe/plan',
            method: 'POST',
            body: {
                planId,
                coupon,
            },
            workspaceId,
        });
    });
}
function updateStripePlan(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, planId, coupon, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: 'stripe/plan/update',
            method: 'POST',
            body: {
                planId,
                coupon,
            },
            workspaceId,
        });
    });
}
function updateStripeSubscriptionPaymentMethod(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, token, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: 'stripe/payment',
            method: 'POST',
            body: {
                token,
            },
            workspaceId,
        });
    });
}
function changePlan(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, newPlan, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: `change?newPlan=${newPlan}`,
            method: 'GET',
            workspaceId,
        });
    });
}
function listStripeInvoices(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, limit = 4, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: `stripe/invoices?${(0, querystring_1.stringify)({ limit })}`,
            method: 'GET',
            workspaceId,
        });
    });
}
function retrieveUpcomingInvoice(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: `stripe/invoices/upcoming`,
            method: 'GET',
            workspaceId,
        });
    });
}
function getPlan(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, plan, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: `plan/${plan}`,
            method: 'GET',
            workspaceId,
        });
    });
}
function getSubscriptionPlan(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: `plan`,
            method: 'GET',
            workspaceId,
        });
    });
}
/**
 * List all available plans to purchase
 */
function listPlans(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: `plans/list`,
            method: 'GET',
            workspaceId,
        });
    });
}
/**
 *
 * @param couponCode Stripe coupon code
 * @returns StripeCoupon object if coupon exists
 * @throws If coupon does not
 */
function getCoupon(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, couponCode, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: `coupon/${couponCode}`,
            method: 'GET',
            workspaceId,
        });
    });
}
function getSalesTax(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, request = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: `salestax`,
            method: 'POST',
            body: request,
            workspaceId,
        });
    });
}
function getBillingContact(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: `billingContact`,
            method: 'GET',
            workspaceId,
        });
    });
}
function updateBillingContact(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, billingContact, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.subscriptions, {
            endpoint: `billingContact`,
            method: 'PUT',
            body: billingContact,
            workspaceId,
        });
    });
}
exports.Subscriptions = {
    get,
    purchaseThroughStripe,
    purchaseStripePlan,
    updateStripePlan,
    updateStripeSubscriptionPaymentMethod,
    changePlan,
    listStripeInvoices,
    retrieveUpcomingInvoice,
    getPlan,
    getSubscriptionPlan,
    listPlans,
    getCoupon,
    getSalesTax,
    getBillingContact,
    updateBillingContact,
};
//# sourceMappingURL=subscriptions.js.map